export default __webpack_public_path__ + "static/media/logo-white.db5a0ec8.png";